module.exports = __webpack_public_path__ + "static/media/no-img.6732bd42.png";